import createNewCalloutDelegate from './CalloutDelegate';
export * from './Callout';
export default createNewCalloutDelegate;